import React from "react";
import { Container, Grid, Box, Typography, Tooltip, Avatar } from "@mui/material";
import { motion } from "framer-motion";

const rankingData = [
  {
    category: "Compromiso con el club",
    top5: [
      { name: "Snorlax", img: "/images/ranking/perfil6.jpg", desc: "Colaboró con proyectos clave del club." },
      { name: "Hengar", img: "/images/ranking/perfil7.jpg", desc: "Participación activa en eventos del club." },
      { name: "Squirtle", img: "/images/ranking/perfil8.jpg", desc: "Aportó ideas innovadoras." },
      { name: "Charmander", img: "/images/ranking/perfil9.jpg", desc: "Apoyo logístico y de comunicación." },
      { name: "Pikachu", img: "/images/ranking/perfil10.jpg", desc: "Ayudó en campañas solidarias." },
    ],
    promise: { name: "Bob", img: "/images/ranking/perfil26.jpg", desc: "Emergiendo como nuevo líder en la colaboración." },
  },

   {
    category: "Creación de contenido",
    top5: [
      { name: "Bombom", img: "/images/ranking/perfil1.jpg", desc: "Colaboró con proyectos clave del club." },
      { name: "Bellota", img: "/images/ranking/perfil2.jpg", desc: "Participación activa en eventos del club." },
      { name: "Panda", img: "/images/ranking/perfil3.jpg", desc: "Aportó ideas innovadoras." },
      { name: "Polar", img: "/images/ranking/perfil4.jpg", desc: "Apoyo logístico y de comunicación." },
      { name: "Phyduck", img: "/images/ranking/perfil5.jpg", desc: "Ayudó en campañas solidarias." },
    ],
    promise: { name: "Patricio", img: "/images/ranking/perfil27.jpg", desc: "Emergiendo como nuevo líder en la colaboración." },
  },

   {
    category: "Rendimiento Deportivo",
    top5: [
      { name: "Evee", img: "/images/ranking/perfil11.jpg", desc: "Colaboró con proyectos clave del club." },
      { name: "Buobuofet 2", img: "/images/ranking/perfil12.jpg", desc: "Participación activa en eventos del club." },
      { name: "Naruto", img: "/images/ranking/perfil13.jpg", desc: "Aportó ideas innovadoras." },
      { name: "Gaara", img: "/images/ranking/perfil14.jpg", desc: "Apoyo logístico y de comunicación." },
      { name: "Kakashi", img: "/images/ranking/perfil15.jpg", desc: "Ayudó en campañas solidarias." },
    ],
    promise: { name: "Cosmo", img: "/images/ranking/perfil28.jpg", desc: "Emergiendo como nuevo líder en la colaboración." },
  },

   {
    category: "Liderazgo y compromiso",
    top5: [
      { name: "Sasori", img: "/images/ranking/perfil16.jpg", desc: "Colaboró con proyectos clave del club." },
      { name: "Pain", img: "/images/ranking/perfil17.jpg", desc: "Participación activa en eventos del club." },
      { name: "Shisui", img: "/images/ranking/perfil18.jpg", desc: "Aportó ideas innovadoras." },
      { name: "Konan", img: "/images/ranking/perfil19.jpg", desc: "Apoyo logístico y de comunicación." },
      { name: "Chooji", img: "/images/ranking/perfil20.jpg", desc: "Ayudó en campañas solidarias." },
    ],
    promise: { name: "Wanda", img: "/images/ranking/perfil29.jpg", desc: "Emergiendo como nuevo líder en la colaboración." },
  },

   {
    category: "Acciones Comunidad",
    top5: [
      { name: "Temari", img: "/images/ranking/perfil21.jpg", desc: "Colaboró con proyectos clave del club." },
      { name: "Ten Ten", img: "/images/ranking/perfil22.jpg", desc: "Participación activa en eventos del club." },
      { name: "Rin", img: "/images/ranking/perfil23.jpg", desc: "Aportó ideas innovadoras." },
      { name: "Itachi", img: "/images/ranking/perfil24.jpg", desc: "Apoyo logístico y de comunicación." },
      { name: "Timmy", img: "/images/ranking/perfil25.jpg", desc: "Ayudó en campañas solidarias." },
    ],
    promise: { name: "Dipper", img: "/images/ranking/perfil30.jpg", desc: "Emergiendo como nuevo líder en la colaboración." },
  },

  
 
  // ... repetir para las 3 categorías restantes
];

const Ranking = () => {
  return (
    <Box sx={{ background: "#111", minHeight: "100vh", py: 8 }}>
      <Container>
        <Typography
          variant="h3"
          sx={{ color: "#FF6F00", textAlign: "center", mb: 6, fontWeight: "bold" }}
        >
          Ranking
        </Typography>
        <Grid container spacing={4}>
          {rankingData.map((col, i) => (
            <Grid item xs={12} sm={6} md={2.4} key={i}>
              <motion.div
                initial={{ opacity: 0, y: 50 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: i * 0.2 }}
              >
                <Box
                  sx={{
                    background: "#1e1e1e",
                    borderRadius: "12px",
                    p: 2,
                    textAlign: "center",
                    boxShadow: "0px 4px 12px rgba(0,0,0,0.5)",
                  }}
                >
                  <Typography variant="h6" sx={{ color: "#fff", mb: 2 }}>
                    {col.category}
                  </Typography>
                  {col.top5.map((player, index) => (
                    <Tooltip key={index} title={player.desc} arrow>
                      <Box sx={{ mb: 1 }}>
                        <Avatar
                          src={player.img}
                          alt={player.name}
                          sx={{
                            width: 80,
                            height: 80,
                            border: "3px solid #FF6F00",
                            mx: "auto",
                          }}
                        />
                        <Typography sx={{ color: "#ddd", fontSize: "0.85rem", mt: 0.5 }}>
                          {`${index + 1}. ${player.name}`}
                        </Typography>
                      </Box>
                    </Tooltip>
                  ))}
                  <Box sx={{ mt: 3 }}>
                    <Typography sx={{ color: "#FF6F00", fontWeight: "bold", mb: 1 }}>
                      Promesa
                    </Typography>
                    <Tooltip title={col.promise.desc} arrow>
                      <Avatar
                        src={col.promise.img}
                        alt={col.promise.name}
                        sx={{
                          width: 70,
                          height: 70,
                          border: "3px solid #FFD700",
                          mx: "auto",
                        }}
                      />
                    </Tooltip>
                    <Typography sx={{ color: "#FFD700", fontSize: "0.85rem", mt: 0.5 }}>
                      {col.promise.name}
                    </Typography>
                  </Box>
                </Box>
              </motion.div>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
};

export default Ranking;
